import { render } from "./PackItSnackIt.vue?vue&type=template&id=0ae11809&scoped=true"
const script = {}

import "./PackItSnackIt.vue?vue&type=style&index=0&id=0ae11809&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae11809"]])

export default __exports__